(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-v2"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-v2"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
  
      this.headerType = this.dataset.type;
  	  window.addEventListener("DOMContentLoaded", () => {
  		  const menuDrawerCloseButtons = document.querySelectorAll(".menu-drawer-close-button");
        if (!menuDrawerCloseButtons || menuDrawerCloseButtons.length === 0) return;
          menuDrawerCloseButtons.forEach(button => button.addEventListener("click", () => this.handleTransparency()));
        });
    }

    connectedCallback() {
      this.header = this;
      this.headerBounds = {};
      this.lastScrollY = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
      this.upDistance = 0;
      this.downDistance = 0;
      this.scrollTicking = false;
      this.isHidden = false;
      this.preventRevealDuration = 140;
      this.preventRevealUntil = 0;
      this.hideDistanceThreshold = 34;
      this.revealDistanceThreshold = 22;
      this.header.classList.add('shopify-section-header-sticky');

      this.onScrollRaf = this.onScroll.bind(this);
      this.onScrollHandler = () => {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        window.requestAnimationFrame(this.onScrollRaf);
      };
      this.hideHeaderOnScrollUp = () => {
        this.preventRevealUntil = Date.now() + this.preventRevealDuration;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
      this.handleTransparency();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    handleTransparency(never = false) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerType === 'header-no-transparent') return;

      if (
        location.pathname === "/" || location.pathname === "/ar" 
        || location.pathname === "/fr" || location.pathname === "/pages/hugo"
        || location.pathname === "/pages/boss"
        ) {
        const thisContainsTransparentClass = this.classList.contains("header-transparent");

        if (thisContainsTransparentClass && never) {
          this.classList.remove("header-transparent");
          return;
        }
  
        if (scrollTop < 80) {
          if (!thisContainsTransparentClass) {
            this.classList.add("header-transparent");
          }
        } else {
          if (thisContainsTransparentClass) {
            this.classList.remove("header-transparent");
          }
        }
      }
    }

    onScroll() {
      this.scrollTicking = false;

      const cartNotification = document.getElementById("cart-notification");
      const scrollTop = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);

      if (cartNotification && cartNotification?.classList?.contains("active")) {
        this.lastScrollY = scrollTop;
        return;
      }

      this.handleTransparency();

      const delta = scrollTop - this.lastScrollY;
      const stickyBoundary = this.headerBounds.bottom || this.header.offsetHeight || 0;
      const resetThreshold = 8;
      const hideActivationY = Math.max(stickyBoundary + 40, 160);

      if (delta > 0.5) {
        this.downDistance += delta;
        this.upDistance = 0;
      } else if (delta < -0.5) {
        this.upDistance += Math.abs(delta);
        this.downDistance = 0;
      }

      if (scrollTop <= resetThreshold) {
        this.reset();
        this.isHidden = false;
        this.downDistance = 0;
        this.upDistance = 0;
      } else {
        if (!this.isHidden && this.downDistance > this.hideDistanceThreshold && scrollTop > hideActivationY) {
          this.hide();
          this.isHidden = true;
          this.downDistance = 0;
          this.upDistance = 0;
        }

        if (
          this.isHidden &&
          this.upDistance > this.revealDistanceThreshold &&
          Date.now() >= this.preventRevealUntil
        ) {
          this.reveal();
          this.isHidden = false;
          this.downDistance = 0;
          this.upDistance = 0;
        }
      }

      this.lastScrollY = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
      this.handleTransparency(false);
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
      this.handleTransparency(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
  
  	  window.addEventListener("DOMContentLoaded", () => {
  		const menuDrawerCloseButtons = document.querySelectorAll(".menu-drawer-close-button");
  		if (!menuDrawerCloseButtons || menuDrawerCloseButtons.length === 0) return;
  		menuDrawerCloseButtons.forEach(button => button.addEventListener("click", () => this.handleTransparency()));
  	  });
    }

    connectedCallback() {
      this.header = this;
      this.headerBounds = {};
      this.lastScrollY = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
      this.upDistance = 0;
      this.downDistance = 0;
      this.scrollTicking = false;
      this.isHidden = false;
      this.preventRevealDuration = 140;
      this.preventRevealUntil = 0;
      this.hideDistanceThreshold = 34;
      this.revealDistanceThreshold = 22;
      this.header.classList.add('shopify-section-header-sticky');

      this.onScrollRaf = this.onScroll.bind(this);
      this.onScrollHandler = () => {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        window.requestAnimationFrame(this.onScrollRaf);
      };
      this.hideHeaderOnScrollUp = () => {
        this.preventRevealUntil = Date.now() + this.preventRevealDuration;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
      this.handleTransparency();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    handleTransparency(never = false) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (
        location.pathname === "/" || location.pathname === "/ar" 
        || location.pathname === "/fr" || location.pathname === "/pages/hugo"
        || location.pathname === "/pages/boss"
        ) {
        const thisContainsTransparentClass = this.classList.contains("header-transparent");

        if (thisContainsTransparentClass && never) {
          this.classList.remove("header-transparent");
          return;
        }
  
        if (scrollTop < 80) {
          if (!thisContainsTransparentClass) {
            this.classList.add("header-transparent");
          }
        } else {
          if (thisContainsTransparentClass) {
            this.classList.remove("header-transparent");
          }
        }
      }
    }

    onScroll() {
      this.scrollTicking = false;

      const cartNotification = document.getElementById("cart-notification");
      const scrollTop = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);

      if (cartNotification && cartNotification?.classList?.contains("active")) {
        this.lastScrollY = scrollTop;
        return;
      }

      this.handleTransparency();

      const delta = scrollTop - this.lastScrollY;
      const stickyBoundary = this.headerBounds.bottom || this.header.offsetHeight || 0;
      const resetThreshold = 8;
      const hideActivationY = Math.max(stickyBoundary + 40, 160);

      if (delta > 0.5) {
        this.downDistance += delta;
        this.upDistance = 0;
      } else if (delta < -0.5) {
        this.upDistance += Math.abs(delta);
        this.downDistance = 0;
      }

      if (scrollTop <= resetThreshold) {
        this.reset();
        this.isHidden = false;
        this.downDistance = 0;
        this.upDistance = 0;
      } else {
        if (!this.isHidden && this.downDistance > this.hideDistanceThreshold && scrollTop > hideActivationY) {
          this.hide();
          this.isHidden = true;
          this.downDistance = 0;
          this.upDistance = 0;
        }

        if (
          this.isHidden &&
          this.upDistance > this.revealDistanceThreshold &&
          Date.now() >= this.preventRevealUntil
        ) {
          this.reveal();
          this.isHidden = false;
          this.downDistance = 0;
          this.upDistance = 0;
        }
      }

      this.lastScrollY = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
      this.handleTransparency(false);
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
      this.handleTransparency(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-gift-wrapper"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items-v2"]) return;
  try {
    
    class GriftWrapper extends HTMLElement {
        constructor() {
          super();

          this.id = this.dataset.itemId;
          this.visibleWrapAsGift = this.querySelector(`#visible-wrap-as-gift-${this.id}`);
          this.visibleWrapAsGift.addEventListener('input', this.handleCheckbox.bind(this));
        }

        handleCheckbox(e) {
            e.preventDefault();
            if (e.target.checked) {
                e.target.value = "Yes";
            } else {
                e.target.value = "No";
            };
            this.cartUpdateRequest();
        }

        cartUpdateRequest() {
            let visibleWrapAsGift = this.visibleWrapAsGift.value;
            const body = JSON.stringify({ id: this.id, properties: { 'Wrap as gift': visibleWrapAsGift } });
            fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }});
        }
    }

    customElements.define('gift-wrapper', GriftWrapper);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
    class GriftWrapper extends HTMLElement {
        constructor() {
          super();

          this.id = this.dataset.itemId;
          this.visibleWrapAsGift = this.querySelector(`#visible-wrap-as-gift-${this.id}`);
          this.visibleWrapAsGift.addEventListener('input', this.handleCheckbox.bind(this));
        }

        handleCheckbox(e) {
            e.preventDefault();
            if (e.target.checked) {
                e.target.value = "Yes";
            } else {
                e.target.value = "No";
            };
            this.cartUpdateRequest();
        }

        cartUpdateRequest() {
            let visibleWrapAsGift = this.visibleWrapAsGift.value;
            const body = JSON.stringify({ id: this.id, properties: { 'Wrap as gift': visibleWrapAsGift } });
            fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }});
        }
    }

    customElements.define('gift-wrapper', GriftWrapper);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-note-wrapper"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-v2"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            handleProductQuickView();
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            handleProductQuickView();
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
